/* mo-pdx-buy.js: behavior for the redesigned PDP first screens (buy lane, 2026-10-17). Deferred, no libraries.
   1. Stage height: the gallery fills the rest of the first screen (CSS reads --pdx-stage-top).
   2. Photo count "1 / 6" and tap-to-zoom on the Flickity stage (the theme's product-slider stays in charge).
   3. Thumbnails answer Enter and Space.
   4. Description clamp with Read more (the full text stays in the server HTML).
   5. The sticky bar under the header: shown once the main add-to-cart has scrolled out, hidden at the footer,
      selected size kept current on the form's id change (fires after product.js has the new variant).
   Text updates write nodeValue (characterData), so assets/custom.js' body childList observer is not woken. */
(function () {
  'use strict';
  var root = document.querySelector('.thb-product-detail.mo-pdx');
  if (!root) return;
  var desk = window.matchMedia('(min-width: 1024px)');
  var wide = window.matchMedia('(min-width: 1200px)');

  function setText(el, text) {
    if (!el) return;
    if (el.firstChild && el.firstChild.nodeType === 3 && el.childNodes.length === 1) {
      if (el.firstChild.nodeValue !== text) el.firstChild.nodeValue = text;
    } else {
      el.textContent = text;
    }
  }

  /* 1. stage height ------------------------------------------------------------ */
  var gallery = root.querySelector('.pdx-gallery');
  var grid = root.querySelector('.pdx-grid');
  var head = root.querySelector('.pdx-head');
  var lastTop = -1;
  function measureStage() {
    if (!gallery || !grid) return;
    var ref = desk.matches ? grid : gallery;
    var top = Math.round(ref.getBoundingClientRect().top + window.scrollY);
    if (desk.matches) top += parseFloat(getComputedStyle(gallery).marginTop) || 0;
    if (Math.abs(top - lastTop) < 2) { fitRail(); fitSlides(); return; }
    lastTop = top;
    gallery.style.setProperty('--pdx-stage-top', top + 'px');
    requestAnimationFrame(function () { fitRail(); fitSlides(); });
  }
  /* the rail shows whole thumbnails only, above the lowest 240 px of the first screen; thumbs scrolled out of the
     rail are visibility:hidden (they stay clickable for product.js, which binds clicks once by clientWidth) */
  var rail = root.querySelector('.pdx-thumbs');
  var stageBox = root.querySelector('.pdx-stage');
  var railList = rail ? rail.querySelector('.product-thumbnail-container') : null;
  var railUp = root.querySelector('.pdx-railbtn--up'), railDown = root.querySelector('.pdx-railbtn--down');
  var STEP = 68;
  function railState() {
    if (!railList || !wide.matches) return;
    var rt = railList.getBoundingClientRect();
    Array.prototype.forEach.call(railList.children, function (t) {
      var r = t.getBoundingClientRect();
      var out = r.bottom <= rt.top + 2 || r.top >= rt.bottom - 2;
      if ((t.style.visibility === 'hidden') !== out) t.style.visibility = out ? 'hidden' : '';
    });
    var over = railList.scrollHeight > railList.clientHeight + 2;
    if (railUp) { railUp.hidden = !over; railUp.disabled = railList.scrollTop <= 2; }
    if (railDown) { railDown.hidden = !over; railDown.disabled = railList.scrollTop + railList.clientHeight >= railList.scrollHeight - 2; }
  }
  function fitRail() {
    if (!rail || !railList) return;
    var stage = root.querySelector('.pdx-slider');
    if (!wide.matches || !stage) { rail.style.maxHeight = ''; railList.style.maxHeight = ''; return; }
    var n = railList.children.length, room = stage.getBoundingClientRect().height - 240;
    var fit = Math.max(2, Math.floor((room + 8) / STEP));
    if (n > fit) fit = Math.max(2, Math.floor((room - 40 + 8) / STEP)); /* leave a row for the up/down buttons */
    var h = Math.min(n, fit) * STEP - 8 + 4;
    rail.style.maxHeight = h + 'px';
    railList.style.maxHeight = h + 'px'; /* scroll-shadow slots the list, so max-height: inherit would not reach it */
    if (stageBox) stageBox.style.setProperty('--pdx-rail-h', h + 'px');
    railState();
  }
  var rq = 0;
  if (railList) railList.addEventListener('scroll', function () { if (rq) return; rq = requestAnimationFrame(function () { rq = 0; railState(); }); }, { passive: true });
  [railUp, railDown].forEach(function (b) {
    if (b) b.addEventListener('click', function () { railList.scrollBy({ top: STEP * Number(b.getAttribute('data-pdx-rail')), behavior: 'smooth' }); });
  });
  fitRail();

  /* the photo fills the stage only when its shape is close to the stage's; otherwise it stays whole over a blurred copy of
     itself (CSS ::before), so the stage reads as photo without cutting the product */
  var COVER_MAX = 1.25; /* at most 20 % of the photo is cropped; a bed at the edge stays whole */
  function fitSlides() {
    if (!slider) return;
    var w = slider.clientWidth, h = slider.getBoundingClientRect().height;
    if (!w || !h) return;
    var s = w / h;
    slider.querySelectorAll('.product-images__slide[data-pdx-ar]').forEach(function (el) {
      var a = parseFloat(el.getAttribute('data-pdx-ar')) || 0;
      var img = el.querySelector('.product-single__media-image');
      var k = a && el.getAttribute('data-pdx-fit') !== 'contain' ? Math.max(a / s, s / a) : 99;
      el.classList.toggle('pdx-cover', !!img && k <= COVER_MAX);
    });
  }
  var mt;
  function queueMeasure() { clearTimeout(mt); mt = setTimeout(measureStage, 120); }
  measureStage();
  window.addEventListener('resize', queueMeasure, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueMeasure);
  if (head && 'ResizeObserver' in window) {
    var startY = window.scrollY;
    new ResizeObserver(function () { if (window.scrollY <= startY + 4) queueMeasure(); }).observe(head);
  }

  /* 2. photo count and tap-to-zoom ---------------------------------------------- */
  var slider = root.querySelector('#Product-Slider');
  fitSlides();
  var count = root.querySelector('[data-pdx-count]');
  function cells() { return slider ? Array.prototype.slice.call(slider.querySelectorAll('.product-images__slide.is-active')) : []; }
  function updateCount() {
    if (!count) return;
    var list = cells();
    var i = 0;
    for (var k = 0; k < list.length; k++) { if (list[k].classList.contains('is-selected')) { i = k; break; } }
    setText(count, String(i + 1));
  }
  if (slider && count && 'MutationObserver' in window) {
    var ct;
    new MutationObserver(function () { clearTimeout(ct); ct = setTimeout(updateCount, 30); })
      .observe(slider, { attributes: true, attributeFilter: ['class'], subtree: true });
    updateCount();
  }
  var zoomBound = null;
  function bindZoom() {
    if (!slider || !slider.flkty || zoomBound === slider.flkty) return;
    zoomBound = slider.flkty;
    slider.flkty.on('staticClick', function (event, pointer, cellEl) {
      if (!cellEl || (event && event.target && event.target.closest && event.target.closest('a, button, video, iframe, model-viewer'))) return;
      var zoom = cellEl.querySelector('.product-single__media-image .product-single__media-zoom');
      if (zoom) zoom.click();
    });
  }
  bindZoom();
  /* the theme's arrow buttons carry only an icon; give them names (product.js clones them, clones keep attributes) */
  function nameArrows() {
    if (!slider) return;
    var p = slider.querySelector('.flickity-prev'), n = slider.querySelector('.flickity-next');
    if (p && !p.hasAttribute('aria-label')) p.setAttribute('aria-label', 'Previous photo');
    if (n && !n.hasAttribute('aria-label')) n.setAttribute('aria-label', 'Next photo');
  }
  nameArrows(); setTimeout(nameArrows, 600);
  /* keyboard: Flickity moves with the arrow keys; Enter on the focused stage opens the same zoom (the theme's zoom link
     is tabindex -1) */
  if (slider) slider.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.target !== slider) return;
    var cell = slider.querySelector('.product-images__slide.is-selected') || slider.querySelector('.product-images__slide');
    var zoom = cell && cell.querySelector('.product-single__media-image .product-single__media-zoom');
    if (zoom) { e.preventDefault(); zoom.click(); }
  });
  if (slider) slider.addEventListener('pointerdown', bindZoom, { passive: true });

  /* option chips: the column minimum comes from the server (product-option.liquid sums the label widths, the CSS turns it
     into --pdx-opt-min), so the first layout is final. JS measures a group only when a label really overflows once fonts
     are in, or after product.js flips data-available (a size change on two-option products, so after input) */
  var cv = document.createElement('canvas').getContext('2d');
  function tw(el) {
    if (!el) return 0;
    var c = getComputedStyle(el), t = el.textContent.trim();
    cv.font = c.fontStyle + ' ' + c.fontWeight + ' ' + c.fontSize + ' ' + c.fontFamily; /* the shorthand is '' with tabular-nums */
    return cv.measureText(t).width + (parseFloat(c.letterSpacing) || 0) * t.length;
  }
  function fitOne(fs) {
    var max = 0, l0 = fs.querySelector('label.pdx-opt__chip');
    fs.querySelectorAll('label.pdx-opt__chip').forEach(function (l) {
      var w = tw(l.querySelector('.pdx-opt__name'));
      var inp = l.previousElementSibling, soldable = inp && inp.getAttribute('data-available') === 'false';
      var tail = Math.max(tw(l.querySelector('.pdx-opt__sub')), soldable ? tw(l.querySelector('.pdx-opt__so')) : 0);
      if (tail) w += tail + (parseFloat(getComputedStyle(l).columnGap) || 6);
      if (w > max) max = w;
    });
    var pad = l0 ? (parseFloat(getComputedStyle(l0).paddingLeft) - 2) * 2 : 20; /* same rule as the CSS: 2 px of each side's padding may go */
    if (max) fs.style.setProperty('--pdx-opt-min', Math.ceil(max + pad) + 'px');
  }
  function overflows(fs) {
    return Array.prototype.some.call(fs.querySelectorAll('label.pdx-opt__chip'), function (l) { return l.scrollWidth > l.clientWidth + 2; });
  }
  function guardOpts() { root.querySelectorAll('.pdx-opt').forEach(function (fs) { if (fs.style.getPropertyValue('--pdx-opt-min') || overflows(fs)) fitOne(fs); }); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(guardOpts); else guardOpts();
  var ot; function queueOpts() { clearTimeout(ot); ot = setTimeout(guardOpts, 150); }
  window.addEventListener('resize', queueOpts, { passive: true });
  /* product.js rewrites data-available after each size change (other option groups); re-measure then */
  var vsel = root.querySelector('variant-selects.pdx-variants');
  if (vsel && root.querySelectorAll('.pdx-opt').length > 1) new MutationObserver(function () { clearTimeout(ot); ot = setTimeout(function () { root.querySelectorAll('.pdx-opt').forEach(fitOne); }, 150); }).observe(vsel, { attributes: true, attributeFilter: ['data-available'], subtree: true });

  /* 3. thumbnails: Enter and Space, and a click path of our own (product.js binds thumbs once, only those visible
     at load, so a rail that appears after a resize would otherwise be dead) */
  root.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.pdx-thumbs .product-thumbnail') : null;
    if (!t || !slider || !slider.flkty) return;
    var list = Array.prototype.filter.call(root.querySelectorAll('.pdx-thumbs .product-thumbnail'), function (x) { return x.classList.contains('is-active'); });
    var i = list.indexOf(t);
    if (i > -1 && slider.flkty.selectedIndex !== i) slider.flkty.select(i);
  });
  root.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('product-thumbnail') || t.getAttribute('role') !== 'button') return;
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
  });

  /* 4. description fold: whole blocks after the first ~200 px are hidden until Read more (no line is cut in half;
     the full text stays in the server HTML) */
  root.querySelectorAll('[data-pdx-clamp]').forEach(function (box) {
    var body = box.querySelector('.pdx-desc__body');
    var btn = box.querySelector('.pdx-desc__more');
    if (!body || !btn || body.scrollHeight <= 280) return;
    var host = body;
    while (host.children.length === 1 && host.firstElementChild.children.length > 1) host = host.firstElementChild;
    var kids = Array.prototype.slice.call(host.children);
    var top0 = body.getBoundingClientRect().top, folded = 0;
    kids.forEach(function (k, i) {
      var bottom = k.getBoundingClientRect().bottom - top0;
      if (i > 0 && bottom > 210) { k.classList.add('pdx-fold'); folded++; }
    });
    if (!folded) return;
    box.classList.add('is-clamped');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      box.classList.toggle('is-clamped', !open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) {
        var r = box.getBoundingClientRect();
        if (r.top < 0) window.scrollBy({ top: r.top - 120, behavior: 'auto' });
      }
    });
  });

  /* pickup: the theme's long "Check availability at other stores" button stays in the DOM (it opens the store
     panel); the row shows a short action at its right edge that clicks it */
  var pick = root.querySelector('.pdx-way--pickup pickup-availability');
  var pickAct = root.querySelector('[data-pdx-pickup-act]');
  function syncPick() {
    if (!pick || !pickAct) return;
    var b = pick.querySelector('.pickup-availability-information__button');
    pickAct.hidden = !b;
    if (b) setText(pickAct, /other/i.test(b.textContent) ? 'Other stores' : 'Store info');
  }
  if (pick && pickAct) {
    new MutationObserver(syncPick).observe(pick, { childList: true, subtree: true });
    pickAct.addEventListener('click', function () { var b = pick.querySelector('.pickup-availability-information__button'); if (b) b.click(); });
    syncPick();
  }

  /* 5. sticky bar: the theme's product-add-to-cart-sticky. Its own observer waits until the whole form (Shop Pay
     included) leaves the viewport; the bar now sits under the header, so it also shows as soon as the add-to-cart
     button has passed under the header, and hides when that button is back or the footer is in view. Same class
     (.sticky--visible), so mo-ai-chat.css treats it exactly as before. */
  var bar = root.querySelector('product-add-to-cart-sticky.pdx-sticky');
  var mainBtn = root.querySelector('.pdx-cta button[name="add"]');
  var foot = document.getElementById('footer');
  var footIn = false, sq = 0;
  function headerBottom() {
    if (!document.body.classList.contains('header-sticky--active')) return 0;
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    return v > 0 ? v : 0;
  }
  function syncBar() {
    sq = 0;
    if (!bar || !mainBtn) return;
    var want = mainBtn.getBoundingClientRect().bottom < headerBottom() + 2 && !footIn;
    if (bar.classList.contains('sticky--visible') !== want) bar.classList.toggle('sticky--visible', want);
  }
  if (bar && mainBtn) {
    window.addEventListener('scroll', function () { if (!sq) sq = requestAnimationFrame(syncBar); }, { passive: true });
    if (foot && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { footIn = en[0].isIntersecting; syncBar(); }).observe(foot);
  }

  /* keep the bar's size line current */
  var form = root.querySelector('.pdx-cta form[data-type="add-to-cart-form"]');
  var sizeEl = root.querySelector('[data-pdx-sticky-size]');
  function selectedTitle() {
    var vs = root.querySelector('variant-selects.pdx-variants');
    if (!vs) return '';
    var parts = [];
    vs.querySelectorAll('fieldset').forEach(function (fs) {
      var sel = fs.querySelector('select');
      if (sel) { parts.push(sel.value); return; }
      var c = fs.querySelector('input:checked');
      if (c) parts.push(c.value);
    });
    return parts.join(' / ');
  }
  if (form && sizeEl) {
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.addEventListener('change', function () { var t = selectedTitle(); if (t) setText(sizeEl, t); });
  }
})();
